module.exports = {
  createCompany: 'कंपनी बनाएं',
  createCatalog: 'कैटलॉग बनाएं',
  edit: 'संपादित करें',
  activate: 'सक्रिय',
  deactivate: 'निष्क्रिय करें',
  cancel: 'रद्द करना',
  create: 'सर्जन करना',
  update: 'अद्यतन करें',
  submit: 'जमा करें',
};



// WEBPACK FOOTER //
// ./src/lang/hi/actions.js